var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6369 11.8411C33.744 11.097 33.6904 10.6186 33.369 10.2997C33.0477 9.98077 32.6192 9.92761 32.0835 10.0871L10.8185 18.2194C10.0686 18.5383 9.69368 18.8572 9.69368 19.1761C9.64011 19.5482 9.90793 19.814 10.5507 19.9734L16.0143 21.6743L28.6554 13.7546C28.8161 13.6483 28.9768 13.5951 29.1375 13.5951C29.2982 13.5951 29.4053 13.5951 29.4589 13.7014C29.5124 13.8077 29.4589 13.8609 29.3517 13.9672L19.121 23.1626L18.6925 28.7436C18.9603 28.7436 19.1745 28.6904 19.3888 28.5841C19.4959 28.531 19.6031 28.4247 19.8173 28.212L22.4955 25.6607L28.0126 29.7003C28.4947 30.0192 28.9232 30.0724 29.2446 29.9129C29.566 29.7535 29.8338 29.3814 29.9945 28.7436L33.6369 11.8411Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTg);
export default __webpack_public_path__ + "static/media/icon-tg.ca80e802c11bc038fec797c034eb6073.svg";
export { ForwardRef as ReactComponent };